"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkPhysicsOutlineGameObject = void 0;
var lodash_1 = __importDefault(require("lodash"));
var realms_engine_browser_1 = require("realms-engine-browser");
var realms_engine_network_1 = require("realms-engine-network");
var realms_three_1 = __importDefault(require("realms-three"));
var realms_engine_1 = require("realms-engine");
var NetworkPhysicsOutlineGameObject = /** @class */ (function (_super) {
    __extends(NetworkPhysicsOutlineGameObject, _super);
    // private networkSlave: NetworkSlaveGameObject<any>;
    function NetworkPhysicsOutlineGameObject(outlineState) {
        var _this = _super.call(this, new realms_three_1.default.Group()) || this;
        _this.outlineState = outlineState;
        /*
         * Maps shape id to the THREE Object
         */
        _this.shapeMap = new Map();
        _this.setPosition(outlineState.position);
        _this.setQuaternion(outlineState.quaternion);
        _this.rebuildThreeObject();
        return _this;
    }
    NetworkPhysicsOutlineGameObject.prototype.onSlaveChanges = function (changes, newState) {
        // Update internal state
        if (changes.shapeMap &&
            !lodash_1.default.isEqual(changes.shapeMap, this.outlineState.shapeMap)) {
            // Rebuild shape map from scratch since geometry cant be updated
            this.outlineState.shapeMap = (0, realms_engine_1.mergeChanges)(this.outlineState.shapeMap, changes.shapeMap);
            this.rebuildThreeObject();
        }
        if (changes.position !== undefined) {
            this.setPosition(newState.position);
        }
        if (changes.quaternion !== undefined) {
            this.setQuaternion(newState.quaternion);
        }
    };
    /*
     * Rebuilds the threeJs Object based off the current shape
     */
    NetworkPhysicsOutlineGameObject.prototype.rebuildThreeObject = function () {
        var e_1, _a;
        this.getThreeObject().clear();
        this.shapeMap.clear();
        try {
            // Create shape meshes
            for (var _b = __values(Object.entries(this.outlineState.shapeMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), shapeId = _d[0], outlineShape = _d[1];
                var shapeObject = this.createShapeObject(outlineShape);
                this.getThreeObject().add(shapeObject);
                this.shapeMap.set(shapeId, shapeObject);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /*
     * Create the THREE.Js Shape geometry
     */
    NetworkPhysicsOutlineGameObject.prototype.createShapeObject = function (outlineShape) {
        var geometry;
        switch (outlineShape.type) {
            case realms_engine_network_1.NetworkPhysicsOutlineShapeType.Box: {
                var shape = outlineShape;
                geometry = new realms_three_1.default.BoxGeometry(shape.size.x, shape.size.y, shape.size.z);
                break;
            }
            case realms_engine_network_1.NetworkPhysicsOutlineShapeType.Plane: {
                geometry = new realms_three_1.default.PlaneGeometry(1000, 1000);
                break;
            }
            case realms_engine_network_1.NetworkPhysicsOutlineShapeType.Sphere: {
                var shape = outlineShape;
                geometry = new realms_three_1.default.SphereGeometry(shape.radius);
                break;
            }
            case realms_engine_network_1.NetworkPhysicsOutlineShapeType.Cylinder: {
                var shape = outlineShape;
                geometry = new realms_three_1.default.CylinderGeometry(shape.radiusTop, shape.radiusBottom, shape.height);
                break;
            }
            default: {
                throw new Error("Unsupported NetworkPhysicsOutlineShape: ".concat(outlineShape.type));
            }
        }
        var shapeObject = new realms_three_1.default.Object3D();
        shapeObject.add(new realms_three_1.default.LineSegments(new realms_three_1.default.WireframeGeometry(geometry)));
        // Set position and quat
        if (outlineShape.position) {
            shapeObject.position.set(outlineShape.position.x, outlineShape.position.y, outlineShape.position.z);
        }
        if (outlineShape.quaternion) {
            shapeObject.quaternion.set(outlineShape.quaternion.x, outlineShape.quaternion.y, outlineShape.quaternion.z, outlineShape.quaternion.w);
        }
        return shapeObject;
    };
    return NetworkPhysicsOutlineGameObject;
}(realms_engine_browser_1.Render3DGameObject));
exports.NetworkPhysicsOutlineGameObject = NetworkPhysicsOutlineGameObject;
